import Image from "next/image"
import HeaderContent from "./content"
import styles from "./index.module.scss"
import InstallmentForm from "./form"




const InstallmentHeader = () => {
    return (
        <article className={styles.header}>
            <section className={styles.image_container__header}>
                <Image
                    src="/images/landings/installment/ss-vector.png"
                    layout="fill"
                    alt="ss-vector"
                    objectFit="cover"
                />
            </section>
            
            <section className="container flex flex-column-mb jcb gap-15 align-i-center">

                <header className={styles.content__header + " container flex align-i-center jcb"}>
                    <HeaderContent />
                </header>

                <section className={styles.form__header}>
                    <InstallmentForm />
                </section>
            </section>
        </article>
    )
}

export default InstallmentHeader